import type { Tenant } from '~/api/tenant';
import { RxLogo } from '~/components/ui/Logo';

const DEFAULT_LOGO_SIZE = 44;

interface OfficeLogoProps {
  tenant: Tenant;
  size?: number;
}

/**
 * A marca do escritório do endereço, nas telas anteriores à sessão (login e convite). Sem logo
 * no escritório, a marca da plataforma entra na cor dele — o `TenantGate` já pintou o tema.
 */
export function OfficeLogo({ tenant, size = DEFAULT_LOGO_SIZE }: OfficeLogoProps): JSX.Element {
  if (!tenant.logo_url) {
    return <RxLogo size={size} color="var(--rx-brand)" label={tenant.nome} />;
  }
  return (
    <img
      src={tenant.logo_url}
      alt={tenant.nome}
      width={size}
      height={size}
      style={{ display: 'block', objectFit: 'contain', borderRadius: 10 }}
    />
  );
}
